import { Toaster } from '@/components/ui/sonner.tsx'
import { TooltipProvider } from '@/components/ui/tooltip.tsx'
import { Map } from './components/map/Map.tsx'
import { useLoadMapSession } from '@/js/hooks/useLoadMapSession.ts'

type AppProps = {
    map: string | number
}

function App({ map }: AppProps) {
    useLoadMapSession(map)

    return (
        <div className={'relative'}>
            <TooltipProvider delayDuration={100}>
                <div className={'w-screen h-screen flex flex-row items-stretch'}>
                    <div className={'h-screen flex-1'}>
                        <Map />
                    </div>
                </div>
            </TooltipProvider>

            <Toaster />
        </div>
    )
}

export default App
